import { render, staticRenderFns } from "./input-brand.vue?vue&type=template&id=0c4d9ccb&"
import script from "./input-brand.vue?vue&type=script&lang=js&"
export * from "./input-brand.vue?vue&type=script&lang=js&"
import style0 from "./input-brand.vue?vue&type=style&index=0&id=0c4d9ccb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports